import { useState, type ReactNode } from 'react'

/** O sectiune a setarilor XDR care se strange: titlul si un rand de sumar; continutul ramane montat, doar ascuns. */
export function XdrSection({
  id,
  title,
  summary,
  defaultOpen = false,
  children,
}: {
  id: string
  title: string
  summary?: ReactNode
  defaultOpen?: boolean
  children: ReactNode
}) {
  const [open, setOpen] = useState(defaultOpen)
  return (
    <section className="xdr-section" data-section={id} style={{ borderBottom: '1px solid #e3e8ee' }}>
      <button
        type="button"
        className="xdr-section-head"
        aria-expanded={open}
        aria-controls={`xdr-section-${id}`}
        onClick={() => setOpen((o) => !o)}
        style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'baseline', gap: '4px 10px', width: '100%', padding: '12px 0', background: 'none', border: 0, textAlign: 'left', cursor: 'pointer' }}
      >
        <i className={open ? 'fas fa-chevron-down' : 'fas fa-chevron-right'} aria-hidden="true" style={{ width: 12, color: '#8a99a8' }}></i>
        <strong style={{ fontSize: 15 }}>{title}</strong>
        {summary && (
          <span className="xdr-section-summary text-muted" style={{ fontSize: 12 }}>
            {summary}
          </span>
        )}
      </button>
      <div id={`xdr-section-${id}`} className="xdr-section-body" hidden={!open} style={{ padding: '0 0 16px 22px' }}>
        {children}
      </div>
    </section>
  )
}
